import { Application, Controller } from "@hotwired/stimulus";

class ImageFieldsController extends Controller {
  static targets = ['template', 'container']

  addField(event) {
    event.preventDefault();
    const content = this.templateTarget.innerHTML;
    this.containerTarget.insertAdjacentHTML('beforeend', content);
  }

  removeField(event) {
    event.preventDefault();
    event.target.closest(".image-field").remove()
  }
}

// Registered in admin.js
export { ImageFieldsController };
